import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CommunityProps, CommunityUserFeed } from "../../types";

interface CommunityState {
  Communities: CommunityProps[];
  CommunityMembers: CommunityProps[];
  CommunityMergeUpdate: CommunityUserFeed[]
}

const initialState: CommunityState = {
  Communities: [],
  CommunityMembers: [],
  CommunityMergeUpdate: [],
}

const addCommunitiesSlice = createSlice({
  name: "community",
  initialState,
  reducers: {
    setCommunities: (state, action: PayloadAction<any>) => {
      state.Communities = action.payload;
    },
    setCommunityMembers: (state, action: PayloadAction<any>) => {
      state.CommunityMembers =  action.payload
    },
    setCommunityMergeUpdate: (state, action: PayloadAction<CommunityUserFeed[]>) => {
      // Merge existing feeds with the new ones
      const newFeeds = action.payload;

      // Optionally, remove duplicates or handle other merging logic here
      const uniqueFeeds = [...state.CommunityMergeUpdate, ...newFeeds]
        .filter((feed, index, self) =>
          index === self.findIndex((f) => f.id === feed.id) // Assuming `id` is unique
        );

      state.CommunityMergeUpdate = uniqueFeeds;
    },
  }
});

export const {
  setCommunities,
  setCommunityMembers,
  setCommunityMergeUpdate,
} = addCommunitiesSlice.actions;

export default addCommunitiesSlice.reducer;
